/** Fixed word for "are you sure?" gates; matches the BE's `confirm.Word`. */
export const CONFIRM_WORD = 'CONFIRM';

/** Trimmed, case-sensitive match, mirroring the BE check. */
export function isTypedConfirmMatch(value: string, word: string = CONFIRM_WORD): boolean {
  return value.trim() === word;
}
